import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export const REFERRAL_OPTIONS = ["Google/Search Engine", "Instagram", "Facebook", "Friend or Family", "Returning Customer", "Local Event or Market", "Other"];

export const ReferralQuestion = ({ sessionId }) => {
  const [source, setSource] = useState("");
  const [other, setOther] = useState("");
  const [done, setDone] = useState(false);
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!source) return;
    setSaving(true);
    try {
      await api.post(`/orders/${sessionId}/referral`, { source, other });
      setDone(true);
      toast.success("Thanks — that helps us a lot.");
    } catch {
      toast.error("Could not save your answer — no worries, your order is unaffected.");
    }
    setSaving(false);
  };

  if (done) return <p className="mt-10 font-mono-tech text-[11px] uppercase tracking-[0.2em] text-[#C87455]" data-testid="referral-thanks">Thank you for letting us know.</p>;

  return (
    <div className="mt-10 border border-zinc-800 bg-[#0A0A0A] p-5 text-left" data-testid="referral-question">
      <label htmlFor="referral-source" className="font-mono-tech text-xs uppercase tracking-[0.2em] text-zinc-400 block">How did you hear about us? <span className="text-zinc-600">(optional)</span></label>
      <select
        id="referral-source"
        data-testid="referral-select"
        value={source}
        onChange={(e) => setSource(e.target.value)}
        className="mt-3 w-full bg-black border border-zinc-800 focus:border-[#C87455] text-white text-sm px-3 py-3 rounded-none outline-none"
      >
        <option value="">Select one…</option>
        {REFERRAL_OPTIONS.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
      {source === "Other" && (
        <input
          data-testid="referral-other-input"
          value={other}
          onChange={(e) => setOther(e.target.value.slice(0, 200))}
          placeholder="Tell us more (optional)"
          className="mt-3 w-full bg-transparent border-b border-zinc-800 focus:border-[#C87455] text-white text-sm px-0 py-2 rounded-none outline-none placeholder-zinc-600"
        />
      )}
      <button
        type="button"
        onClick={submit}
        disabled={!source || saving}
        data-testid="referral-submit"
        className="mt-4 bg-[#C87455] text-black hover:bg-[#A65B3E] transition-colors px-6 py-2.5 font-mono-tech text-[10px] uppercase tracking-[0.2em] disabled:opacity-40"
      >
        {saving ? "Saving…" : "Send"}
      </button>
    </div>
  );
};
